"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6371],{

/***/ 84030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42928);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var react_swipeable_list_dist_styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59607);
/* harmony import */ var react_swipeable_list_dist_styles_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_swipeable_list_dist_styles_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83838);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31327);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(66697);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93193);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(96950);
/* harmony import */ var _ui_components_Notification__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97628);
/* harmony import */ var _ui_hooks_useShowHowItWorks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45971);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68866);
/* harmony import */ var _veno_app_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99784);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70079);
/* harmony import */ var react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(58257);
/* harmony import */ var react_swipeable_list__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _MobileOrDesktop__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60303);
/* harmony import */ var _ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21559);












var SwipeableList = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_10__/* .chakra */ .m$)(react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__.SwipeableList);
var HowItWorksDrawer = function(param) {
    var hintType = param.hintType, title = param.title, shortText = param.shortText, shortTextDesktop = param.shortTextDesktop, longText = param.longText;
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslations */ .T_)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), dismissed = ref[0], setDismissed = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), drawerOpen = ref1[0], setDrawerOpen = ref1[1];
    var closeDrawer = function() {
        return setDrawerOpen(false);
    };
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_ui_hooks_useShowHowItWorks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(hintType), 1), showHowItWorks = ref2[0];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), hiddenElementOpacity = ref3[0], setHiddenElementOpacity = ref3[1];
    var notificationNode = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_components_Notification__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        mx: {
            base: "16px",
            desktop: "0"
        },
        mt: "10px",
        mb: {
            base: "27px",
            desktop: "10px"
        },
        flexGrow: {
            base: 1,
            desktop: 0
        },
        p: {
            base: "10px",
            desktop: "24px"
        },
        h: {
            base: "83px",
            desktop: "auto"
        },
        flexShrink: 0,
        textWidth: {
            base: "248px",
            desktop: "none"
        },
        button: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .zx, {
            size: {
                base: "sm",
                desktop: "md"
            },
            onClick: function() {
                return setDrawerOpen(true);
            },
            children: t("View")
        }),
        title: t("How does it work?"),
        text: shortText,
        textDesktop: shortTextDesktop
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            showHowItWorks && !dismissed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_8__/* .InDesktop */ .Fe, {
                children: notificationNode
            }),
            showHowItWorks && !dismissed && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_8__/* .InMobile */ .FN, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SwipeableList, {
                    flex: 0,
                    type: react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__.Type.IOS,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__.SwipeableListItem, {
                        trailingActions: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__.TrailingActions, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_swipeable_list__WEBPACK_IMPORTED_MODULE_7__.SwipeAction, {
                                onClick: function() {},
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .zx, {
                                    onClick: function() {
                                        return setDismissed(true);
                                    },
                                    m: "10px",
                                    variant: "raised",
                                    w: "87px",
                                    h: "83px",
                                    overflow: "hidden",
                                    opacity: hiddenElementOpacity,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Flex */ .kC, {
                                        flexDir: "column",
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .xu, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_14__/* .Icon */ .JO, {
                                                    as: _veno_app_icons__WEBPACK_IMPORTED_MODULE_5__/* .Trash */ .rF,
                                                    width: "24px",
                                                    height: "24px"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .xv, {
                                                color: "#000000",
                                                children: "Dismiss"
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        onSwipeProgress: function(progress) {
                            setHiddenElementOpacity(progress * 3 / 100);
                        },
                        onSwipeStart: function() {
                            setHiddenElementOpacity(0);
                        },
                        children: notificationNode
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDrawer */ .NH, {
                isOpen: drawerOpen,
                onClose: closeDrawer,
                scrollBehavior: "inside",
                placement: "bottom",
                size: {
                    base: "full",
                    desktop: "md"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDrawerOverlay */ .Dx, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDragDrawerContent */ .Zt, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDrawerHeader */ .BB, {
                                children: t("How it works")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_MobileOrDesktop__WEBPACK_IMPORTED_MODULE_8__/* .InDesktop */ .Fe, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_15__/* .DrawerCloseButton */ .cC, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDrawerBodyWithMask */ .tN, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .xv, {
                                        textAlign: "center",
                                        mb: "40px",
                                        textStyle: "h3",
                                        children: title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .xu, {
                                        textStyle: "body",
                                        color: "text-light",
                                        children: longText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ModalOrDrawer_ModalOrDrawerParts__WEBPACK_IMPORTED_MODULE_9__/* .ModalOrDrawerFooter */ .Un, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HowItWorksFooter, {
                                    close: closeDrawer,
                                    hintType: hintType
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var HowItWorksFooter = function(param) {
    var close = param.close, hintType = param.hintType;
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslations */ .T_)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_ui_hooks_useShowHowItWorks__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(hintType), 2), setShowHowItWorks = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .Button */ .zx, {
                onClick: close,
                children: t("Close")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Box */ .xu, {
                textAlign: "center",
                pt: "20px",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .rU, {
                    variant: "secondary",
                    onClick: function() {
                        close();
                        setShowHowItWorks(false);
                    },
                    textAlign: "center",
                    children: t("Don't show it again")
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HowItWorksDrawer);


/***/ }),

/***/ 28939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NC": function() { return /* binding */ DisclaimerDrawer; },
/* harmony export */   "bZ": function() { return /* binding */ DisclaimerDrawerContent; },
/* harmony export */   "y0": function() { return /* binding */ useDisclaimerDrawer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35250);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96950);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66697);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31327);
/* harmony import */ var _ui_components_DragDrawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74288);
/* harmony import */ var _ui_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68866);
/* harmony import */ var _ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7306);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(32848);
/* harmony import */ var _useUseYourTokenDrawer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30840);







var DisclaimerDrawer = function() {
    var isOpen = useDisclaimerDrawer(function(s) {
        return s.isOpen;
    });
    var onClose = useDisclaimerDrawer(function(s) {
        return s.onClose;
    });
    var title = (0,_useUseYourTokenDrawer__WEBPACK_IMPORTED_MODULE_4__/* .useUseYourTokenDrawer */ .I)(function(s) {
        return s.title;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Drawer */ .dy, {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom",
        size: "full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerOverlay */ .P1, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_ui_components_DragDrawer__WEBPACK_IMPORTED_MODULE_1__/* .DragDrawerContent */ .C, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerHeader */ .OX, {
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DisclaimerDrawerContent, {})
                ]
            })
        ]
    });
};
var DisclaimerDrawerContent = function() {
    var t = (0,_ui_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslations */ .T_)();
    var url = useDisclaimerDrawer(function(s) {
        return s.url;
    });
    var onClose = useDisclaimerDrawer(function(s) {
        return s.onClose;
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerBody */ .Ng, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                        textStyle: "h3",
                        textAlign: "center",
                        children: t("Leaving {platform}", {
                            platform: "veno.finance"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .xv, {
                        color: "text-light",
                        mt: "42px",
                        children: t("leaving-veno-desc")
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .DrawerFooter */ .ze, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                        as: "a",
                        href: url !== null && url !== void 0 ? url : undefined,
                        target: "_blank",
                        children: t("Agree & Continue")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .zx, {
                        variant: "link",
                        onClick: onClose,
                        mt: "10px",
                        children: t("Dismiss")
                    })
                ]
            })
        ]
    });
};
var useDisclaimerDrawer = (0,zustand__WEBPACK_IMPORTED_MODULE_8__/* .create */ .Ue)((0,_ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_3__/* .resetWhenRouterChange */ .G)(function(set) {
    return {
        isOpen: false,
        url: null,
        onOpen: function(param) {
            var url = param.url;
            set({
                isOpen: true,
                url: url
            });
        },
        onClose: function() {
            var _obj, ref;
            (ref = (_obj = useDisclaimerDrawer.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
        }
    };
}));


/***/ }),

/***/ 4128:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "G": function() { return /* binding */ UseYourTokenDrawer; },
  "I": function() { return /* reexport */ useUseYourTokenDrawer/* useUseYourTokenDrawer */.I; }
});

// EXTERNAL MODULE: ../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(35250);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+modal@2.2.1_@chakra-ui+system@2.2.12_@types+react@18.0.21_framer-motion@7.4.0_react-dom@18.2.0_react@18.2.0/node_modules/@chakra-ui/modal/dist/index.esm.js + 58 modules
var index_esm = __webpack_require__(96950);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+icon@3.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(93193);
// EXTERNAL MODULE: ./src/components/MobileOrDesktop.tsx
var MobileOrDesktop = __webpack_require__(60303);
// EXTERNAL MODULE: ./src/components/ModalOrDrawer/index.ts
var ModalOrDrawer = __webpack_require__(64881);
// EXTERNAL MODULE: ../packages/icons/dist/esm/index.js + 53 modules
var esm = __webpack_require__(99784);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(31501);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(61079);
// EXTERNAL MODULE: ./src/components/useYourTokenDrawer/DisclaimerDrawer.tsx
var DisclaimerDrawer = __webpack_require__(28939);
// EXTERNAL MODULE: ../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(89874);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+layout@2.1.8_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/layout/dist/index.esm.js
var layout_dist_index_esm = __webpack_require__(66697);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+image@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/image/dist/index.esm.js
var image_dist_index_esm = __webpack_require__(18912);
// EXTERNAL MODULE: ../node_modules/.pnpm/@chakra-ui+button@2.0.11_@chakra-ui+system@2.2.12_react@18.2.0/node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(31327);
// EXTERNAL MODULE: ./src/components/Card/index.ts + 1 modules
var Card = __webpack_require__(99726);
// EXTERNAL MODULE: ./src/i18n/index.ts
var i18n = __webpack_require__(68866);
;// CONCATENATED MODULE: ./src/components/useYourTokenDrawer/ProtocolCard.tsx







var ProtocolCard = function(_param) {
    var title = _param.title, titleTail = _param.titleTail, subtitle = _param.subtitle, logo = _param.logo, description = _param.description, tokens = _param.tokens, tvl = _param.tvl, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "titleTail",
        "subtitle",
        "logo",
        "description",
        "tokens",
        "tvl"
    ]);
    var t = (0,i18n/* useTranslations */.T_)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* Card */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        variant: "button",
        mx: "0",
        my: "0",
        p: "16px",
        cursor: "pointer"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                gap: "8px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(image_dist_index_esm/* Image */.Ee, {
                        src: logo,
                        w: "45px",
                        h: "45px",
                        flexShrink: "0",
                        alt: "protocol logo",
                        objectFit: "cover"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                        flex: "1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                                textStyle: "h4Bold",
                                justify: "space-between",
                                alignItems: "center",
                                gap: "8px",
                                children: [
                                    title,
                                    titleTail && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                        children: titleTail
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                                color: "text-light",
                                mt: "4px",
                                children: subtitle
                            })
                        ]
                    })
                ]
            }),
            tvl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Box */.xu, {
                mt: "10px",
                children: [
                    "TVL: ",
                    tvl
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Box */.xu, {
                color: "text-light",
                mt: "10px",
                children: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Flex */.kC, {
                mt: "10px",
                gap: "4px",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout_dist_index_esm/* Text */.xv, {
                        children: [
                            t("Tokens"),
                            ": "
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_dist_index_esm/* Flex */.kC, {
                        flex: "1",
                        alignItems: "center",
                        children: tokens
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(button_dist_index_esm/* Button */.zx, {
                        variant: "link",
                        color: "text-link",
                        ml: "10px",
                        alignSelf: "flex-end",
                        children: t("View")
                    })
                ]
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/useYourTokenDrawer/useUseYourTokenDrawer.ts
var useUseYourTokenDrawer = __webpack_require__(30840);
;// CONCATENATED MODULE: ./src/components/useYourTokenDrawer/DefaultContent.tsx







var DefaultContent = function() {
    var openDisclaimerDrawer = (0,DisclaimerDrawer/* useDisclaimerDrawer */.y0)(function(s) {
        return s.onOpen;
    });
    var protocols = (0,useUseYourTokenDrawer/* useUseYourTokenDrawer */.I)(function(s) {
        return s.protocols;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerBodyWithMask */.tN, {
        maskHeight: 60,
        children: protocols.map(function(protocol, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProtocolCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                mb: "16px"
            }, protocol), {
                onClick: function() {
                    openDisclaimerDrawer({
                        url: protocol.url
                    });
                }
            }), i);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/useYourTokenDrawer/index.tsx










var UseYourTokenDrawer = function() {
    var isOpen = (0,useUseYourTokenDrawer/* useUseYourTokenDrawer */.I)(function(s) {
        return s.isOpen;
    });
    var onClose = (0,useUseYourTokenDrawer/* useUseYourTokenDrawer */.I)(function(s) {
        return s.onClose;
    });
    var title = (0,useUseYourTokenDrawer/* useUseYourTokenDrawer */.I)(function(s) {
        return s.title;
    });
    var url = (0,DisclaimerDrawer/* useDisclaimerDrawer */.y0)(function(s) {
        return s.url;
    });
    var protocols = (0,useUseYourTokenDrawer/* useUseYourTokenDrawer */.I)(function(s) {
        return s.protocols;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDrawer */.NH, {
                placement: "bottom",
                scrollBehavior: "inside",
                isOpen: isOpen,
                onClose: onClose,
                size: {
                    base: "full",
                    desktop: "md"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerOverlay */.Dx, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ModalOrDrawer/* ModalOrDragDrawerContent */.Zt, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* InDesktop */.Fe, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* ModalCloseButton */.ol, {})
                            }),
                            url && !!protocols.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerCloseButton */.M3, {
                                left: "10px",
                                onClick: function(e) {
                                    DisclaimerDrawer/* useDisclaimerDrawer.getState */.y0.getState().onClose();
                                    e.preventDefault();
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                    as: esm/* ArrowBack */.xh,
                                    boxSize: "16px"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalOrDrawer/* ModalOrDrawerHeader */.BB, {
                                children: title
                            }),
                            url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerDrawer/* DisclaimerDrawerContent */.bZ, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DefaultContent, {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileOrDesktop/* RenderInMobile */.ub, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerDrawer/* DisclaimerDrawer */.NC, {})
            })
        ]
    });
};


/***/ }),

/***/ 30840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useUseYourTokenDrawer; }
/* harmony export */ });
/* harmony import */ var _ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7306);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32848);
/* harmony import */ var _DisclaimerDrawer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28939);



var useUseYourTokenDrawer = (0,zustand__WEBPACK_IMPORTED_MODULE_2__/* .create */ .Ue)((0,_ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__/* .resetWhenRouterChange */ .G)(function(set) {
    return {
        isOpen: false,
        title: null,
        protocols: [],
        onOpen: function(param) {
            var title = param.title, protocols = param.protocols;
            set({
                isOpen: true,
                title: title,
                protocols: protocols
            });
        },
        onClose: function() {
            var _obj, ref;
            (ref = (_obj = useUseYourTokenDrawer.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
            _DisclaimerDrawer__WEBPACK_IMPORTED_MODULE_1__/* .useDisclaimerDrawer.getState */ .y0.getState().onClose();
        }
    };
}));


/***/ }),

/***/ 45971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ HintType; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42928);
/* harmony import */ var _usePersistentContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83498);


var HintType;
(function(HintType) {
    HintType[HintType["STAKE"] = 0] = "STAKE";
    HintType[HintType["UNSTAKE"] = 1] = "UNSTAKE";
    HintType[HintType["VNO"] = 2] = "VNO";
})(HintType || (HintType = {}));
var useShowHowItWorks = function(hintType) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_usePersistentContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("".concat(hintType, "-show-how-it-works")), 2), value = ref[0], setValue = ref[1];
    var setShowHowItWorks = function(showHowItWorks) {
        setValue("".concat(showHowItWorks));
    };
    return [
        value !== "false",
        setShowHowItWorks
    ];
};
/* harmony default export */ __webpack_exports__["Z"] = (useShowHowItWorks);


/***/ }),

/***/ 87578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useSupplyLcroModalStore; }
/* harmony export */ });
/* harmony import */ var _ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7306);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32848);


var useSupplyLcroModalStore = (0,zustand__WEBPACK_IMPORTED_MODULE_1__/* .create */ .Ue)((0,_ui_utils_zustandMiddleware__WEBPACK_IMPORTED_MODULE_0__/* .withReset */ .Y)(function(set) {
    return {
        isOpen: false,
        coinMode: "cro",
        close: function() {
            var _obj, ref;
            (ref = (_obj = useSupplyLcroModalStore.getState()).$$resetData) === null || ref === void 0 ? void 0 : ref.call(_obj);
        },
        open: function(param) {
            var type = param.type, coinMode = param.coinMode, onBackward = param.onBackward;
            set({
                isOpen: true,
                type: type,
                coinMode: coinMode,
                onBackward: onBackward
            });
        },
        onBackward: undefined,
        type: "FERRO"
    };
}));


/***/ })

}]);